import { Component, OnInit } from '@angular/core';
import { FloatingMenuService } from '@core/services/floating-menu.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-floating-menu',
  templateUrl: './floating-menu.component.html',
  styleUrls: ['./floating-menu.component.scss']
})
export class FloatingMenuComponent implements OnInit {

  isLoggedIn$: Observable<boolean>;
  showHomeButton: boolean = false;

  constructor(
    private _floatingMenuService: FloatingMenuService
  ) { }

  ngOnInit() {
    this.getDevMode();
  }

  goToDevPortal() {
    this._floatingMenuService.devPortal();
  }

  openFaleConosco() {
    this._floatingMenuService.faleConosco();
  }

  goToWhatsApp() {
    this._floatingMenuService.whatsApp();
  }

  getDevMode() {
    sessionStorage.getItem('devMode') ? this.showHomeButton = true : this.showHomeButton = false
  }

  goToHome() {
    this._floatingMenuService.home();
  }
}
